import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { CSSTransition } from 'react-transition-group';
import CustomLink from "../CustomLink";

const MobileNavItems = styled.div`
    transform: ${({ open }) => !open ? 'translateX(100%)' : 'translateX(0)'};
`;

const RightNav = ({ open, data }) => {
    const [rendered, setRendered] = useState(false);
    
    useEffect(() => {
        setRendered(true)
    }, [])
    if (!data) {
        return null;
    }

    return (
        <>
        {rendered && <MobileNavItems open={open} className={!open ? "navigation-mobile__items" : "navigation-mobile__items is-open"}>
            <div className="navigation-mobile__title">
                <span >{global.$topNavItem}</span>
            </div>

            <NavbarForMobile>
                <DropdownMenu data={data} />
            </NavbarForMobile>

            <div className="navigation-mobile__bottom">
                {data.data.menuItems.filter(menuItem => menuItem.highlight).map( (menuItem, index) => {
                    return (
                        <React.Fragment key={index}>
                            <div key={menuItem.linkURL} className="navigation-mobile__bottom-btn">
                                <CustomLink
                                    linkType={menuItem.linkType}
                                    linkURL={menuItem.linkURL}
                                    className="button button--secondary"
                                >
                                    {menuItem.label}
                                </CustomLink>
                            </div>
                            <div className="navigation-mobile__bottom-desc">Free 14-days trial. No credit card. Easy setup</div>
                        </React.Fragment>
                    )
                })}
            </div>

        </MobileNavItems>
        }
        </>
    )
};

function NavbarForMobile(props) {
    return (
        <nav className="navigation-mobile__list-container navbar">
            <ul className="navigation-mobile__list-items navbar-nav">{props.children}</ul>
        </nav>
    );
}

function DropdownMenu(props) {
    const [activeMenu, setActiveMenu] = useState('main');
    const [, setMenuHeight] = useState(null);
    const dropdownRef = useRef(null);

    const {data} = props.data;

    activeMenu !== 'main'
        ?
        global.$topNavItem =  <DropdownItem
            goToMenu='main'
            isNavigationArrow={true}
        >
            <span className="navigation-mobile__go-back"></span>
        </DropdownItem>
        :
        global.$topNavItem = 'Navigation';

    if(activeMenu === 'menuSubItem1') {
        global.$topNavItem =  <DropdownItem
            goToMenu='menuItemPolyglotDM0'
            isNavigationArrow={true}
        >
            <span className="navigation-mobile__go-back"></span>
        </DropdownItem>
    }

    useEffect(() => {
        setMenuHeight(dropdownRef.current ? dropdownRef.current.firstChild.offsetHeight : null)
    }, [])

    function calcHeight(el) {
        const height = el.offsetHeight;
        setMenuHeight(height);
    }

    function DropdownItem(props) {
        return (
            <React.Fragment>
                {props.hasChildren || props.isNavigationArrow
                    ?
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a href="#" className={props.hasChildren ? "navigation-mobile__submenu-item has-children" : "navigation-mobile__submenu-item"} onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}>
                        {props.children}
                    </a>
                    :
                    <CustomLink
                        linkType={props.linkType}
                        linkURL={props.linkURL}
                        className="navigation-mobile__submenu-item"
                    >
                        {props.linkLabel}
                    </CustomLink>
                }
            </React.Fragment>

        );
    }

    return (
        <div className="dropdown navigation-mobile__submenu" ref={dropdownRef}>


            <CSSTransition
                in={activeMenu === 'main'}
                timeout={500}
                classNames="menu-primary"
                unmountOnExit
                onEnter={calcHeight}>
                <div className="navigation-mobile__submenu-items navigation-mobile__submenu-level1">
                    {data.menuItems && data.menuItems.length > 0 && (
                        <React.Fragment>
                            {data.menuItems.filter(menuItem => !menuItem.highlight).map( (menuItem, index) => {
                                const hasChildren = menuItem.menuItemsLevel2 ? true : false

                                return (
                                    <DropdownItem
                                        hasChildren={hasChildren}
                                        goToMenu={'menuItem' + (menuItem.label).split(' ').join('') + index}
                                        linkLabel={menuItem.label}
                                        linkType={menuItem.linkType}
                                        linkURL={menuItem.linkURL}
                                        key={index}
                                    >
                                        {menuItem.label}
                                    </DropdownItem>
                                )

                            })}
                        </React.Fragment>
                    )}
                </div>
            </CSSTransition>

            {data.menuItems && data.menuItems.length > 0 && (
                <React.Fragment>
                    {data.menuItems.filter(menuItem => !menuItem.highlight).map( (menuItem, index) => {
                        return (
                            <CSSTransition
                                key={index}
                                in={activeMenu === 'menuItem' + (menuItem.label).split(' ').join('') + index}
                                timeout={500}
                                classNames="menu-secondary"
                                unmountOnExit
                                onEnter={calcHeight}>
                                <div className="menu">
                                    {menuItem.menuItemsLevel2 && menuItem.menuItemsLevel2.length > 0 && (
                                        <React.Fragment>
                                            {menuItem.menuItemsLevel2.map( (item, index) => {
                                                const hasLevel3 = item.menuItemsLevel3 ? true : false
                                                return (
                                                    <DropdownItem
                                                        key={index}
                                                        hasChildren={hasLevel3}
                                                        goToMenu={'menuSubItem' + index}
                                                        linkLabel={item.label}
                                                        linkType={item.linkType}
                                                        linkURL={item.linkURL}
                                                    >
                                                        {item.label}
                                                    </DropdownItem>
                                                )
                                            })}
                                        </React.Fragment>

                                    )}
                                </div>
                            </CSSTransition>
                        )

                    })}
                </React.Fragment>

            )}

            {data.menuItems && data.menuItems.length > 0 && (
                <React.Fragment>
                    {data.menuItems.filter(menuItem => !menuItem.highlight).map( (menuItem, index) => {

                        return (
                            <React.Fragment key={index}>
                                {menuItem.menuItemsLevel2 && menuItem.menuItemsLevel2.length > 0 && (
                                    <React.Fragment>
                                        {menuItem.menuItemsLevel2.map( (item, index) => {
                                            const hasLevel3 = item.menuItemsLevel3 ? true : false

                                            return (
                                                hasLevel3
                                                    ?
                                                    <CSSTransition
                                                        key={index}
                                                        in={activeMenu === 'menuSubItem' + index}
                                                        timeout={500}
                                                        classNames="menu-secondary"
                                                        unmountOnExit
                                                        onEnter={calcHeight}>
                                                        <div className="navigation-mobile__submenu-items">
                                                            {item.menuItemsLevel3.map( (item, idx) => {
                                                                return (
                                                                    <DropdownItem
                                                                        key={idx}
                                                                        linkLabel={item.label}
                                                                        linkType={item.linkType}
                                                                        linkURL={item.linkURL}
                                                                    >
                                                                        {item.label}
                                                                    </DropdownItem>
                                                                )
                                                            })}

                                                        </div>
                                                    </CSSTransition>
                                                    :
                                                    null
                                            )
                                        })}
                                    </React.Fragment>

                                )}
                            </React.Fragment>
                        )

                    })}
                </React.Fragment>

            )}

        </div>
    );
}

export default RightNav